export const getSameFromArrayByNumber = (index: number, array: any[]) => {
  if (!array || array?.length === 0) return null
  const remainder = index % array.length

  return array[Math.floor(remainder)]
}
